import { render, staticRenderFns } from "./ManageExtraCharges.vue?vue&type=template&id=72afceb8"
import script from "./ManageExtraCharges.vue?vue&type=script&lang=js"
export * from "./ManageExtraCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports